// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1LhR0","header":"PatientBlock_header__3TF81","label":"PatientBlock_label__35-al","option":"PatientBlock_option__3JE06"};